<template>
  <div class="addInfoWrap">
    <text-tip v-if="tipShow" class="textTip" @closeTip="closeTip">
      <div>您可通过点击“产品代码”列表项内容，查看对应产品的“License使用指南”，以便您获取更多帮助信息。</div>
    </text-tip>
    <el-form :model="form" :rules="rules" ref="formRef" class="addFrom" @submit.native.prevent>
      <el-form-item label="授权码" label-width="65px" prop="code">
        <el-input v-model="form.code" placeholder="请输入授权码" style="width: 350px;">
          <div slot="suffix" class="inputImgWrap">
              <img src="../../../assets/img/delete.svg" @click="deleteCodeValue" v-show="form.code" class="inputImgClass rightClass"  alt="">
              <el-tooltip class="item" effect="dark" offset="10" content="上传授权二维码" placement="top-start">
                <img src="../../../assets/img/code.svg" @click="clickCode" class="inputImgClass"  alt="">
              </el-tooltip>
          </div>
          <!-- <i slot="suffix" class="el-input__icon el-icon-date"></i> -->
        </el-input>
      </el-form-item>
      <el-form-item label-width="12px">
        <el-button type="primary" :loading="loading" @click="add">追加</el-button>
        <el-button type="primary" :loading="loading" @click="batchAdd">批量追加</el-button>
        <el-button type="primary" :loading="loading" plain @click="remove">移除</el-button>
      </el-form-item>
      <div class="rightFlexItem">
        <el-form-item label-width="0">
          <el-button type="primary" plain :loading="loading" @click="seeHelp">查看帮助</el-button>
        </el-form-item>
      </div>
    </el-form>
    <h3c-server-table
    class="serverTable"
    ref="tableObj"
    :url="url"
    :otherColumn="otherColumn"
    primaryKey="id"
    listKey="res"
    :defaultParam="defaultParam"
    @selection-change="handleSelectionChange"
    @data-load-success="dataLoadSuccess"
    @data-load-fail="dataLoadFail">
      <template v-for="column in columns">
        <el-table-column
          v-if="column.prop === 'productCode'"
          :key="column.prop"
          v-bind="column">
          <template slot-scope="scope">
              <div @click="productCodeClick(scope.row.instructionsList)" class="productCode">{{ scope.row.productCode || '' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-else-if="column.prop === 'certificateTime'"
          :key="column.prop"
          v-bind="column">
          <template slot-scope="scope">
              <div>{{ scope.row.certificateTime || '--' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          v-else
          :key="column.prop"
          v-bind="column"
        ></el-table-column>
      </template>
    </h3c-server-table>
      <dialog-code
        v-if="dialogCodeFlag"
        :visible.sync="dialogCodeFlag"
        @cancelCodeDialog="cancelCodeDialog"
        @refeshData="refeshData"
      ></dialog-code>
      <dialog-code-import
        v-if="dialogCodeImportFlag"
        :visible.sync="dialogCodeImportFlag"
        @cancelCodeImportDialog="cancelCodeImportDialog"
      ></dialog-code-import>
      <dialog-common
        v-if="dialogCommon"
        :visible.sync="dialogCommon"
        title="提示"
        @handleConfirm="handleConfirm"
        @handleClose="handleClose">
          <img width="16" height="16" style="margin-right: 8px;" src="../../../assets/img/warn.svg"  alt="">
          <span>您确认要移除选中项吗？</span>
      </dialog-common>
  </div>
</template>
<script>
import requestActiveLicense from "~/request/requestActiveLicense";
import h3cServerTable from "~/components/h3c-server-table.vue";
import textTip from "~/components/text-tip.vue";
import DialogCode from "./Dialog/DialogCode.vue";
import DialogCodeImport from "./Dialog/DialogCodeImport.vue";
import DialogCommon from "./Dialog/DialogCommon.vue";
import {activeLicense} from "~/request/configActiveLicense.js";
import { mapState } from "vuex";
export default {
  components:{
    h3cServerTable,
    textTip,
    DialogCode,
    DialogCodeImport,
    DialogCommon
  },
  data(){
    return{
      otherColumn:{
        selection: {
          'reserve-selection': true,
          'width': 45
        },
        columnIndex: {
          width: 50
        }
      },
      dialogCommon: false,
      currentCheck: [],
      loading: false,
      url: '',
      defaultParam: {},
      dialogCodeImportFlag: false,
      dialogCodeFlag: false,
      tipShow: true,
      form:{
        code: ''
      },
      rules:{
        code:[
            { required: true, message: '请输入授权码', trigger: [] },
            // { required: true, message: '请输入授权码', trigger: ['blur', 'change'] }
            { validator: this.licenseKeyValidate, trigger: [] }
        ],
      },
      columns:[
        {prop: 'licenseKey', label: '授权码', minWidth: '300', 'show-overflow-tooltip': true, sortable: true},
        {prop: 'barCode', label: '软件条码', minWidth: '180', 'show-overflow-tooltip': true, sortable: true},
        {prop: 'productCode', label: '产品代码', minWidth: '110', 'show-overflow-tooltip': true, sortable: true},
        {prop: 'productDesc', label: '产品描述', minWidth: '130', 'show-overflow-tooltip': true, sortable: true},
        {prop: 'keyState', label: '授权码状态', minWidth: '110', 'show-overflow-tooltip': true, sortable: true},
        {prop: 'keyType', label: '授权码类型', minWidth: '110', 'show-overflow-tooltip': true, sortable: true},
        {prop: 'certificateTime', label: '剩余有效时限（天）', minWidth: '160', 'show-overflow-tooltip': true, sortable: true},
      ]
    }
  },
  computed:{
    ...mapState(['processId', 'tableData', 'checkTableData', 'cacheKey'])
  },
  // async mounted(){
  //   if(!this.processId){
  //     // let res = await requestActiveLicense.createProcessId();
  //     // if(res && res.res){
  //     //   this.$store.commit('setProcessId', res.res);
  //     // }
  //     this.$store.commit('setProcessId', '8dda5e68-2d45-42b5-b3d0-c4ff053f4288');
  //     // this.$store.commit('setProcessId', '43980459-8496-46ce-8d1c-be53bbc152df');
  //   }
  //   this.defaultParam = {'processId': this.processId};
  //   this.url = activeLicense.selAuthorizeList;
  // },
  async activated(){
    if(!this.processId){
      let res = await requestActiveLicense.createProcessId();
      if(res && res.res){
        this.$store.commit('setProcessId', res.res);
      }
      // this.$store.commit('setProcessId', '8dda5e68-2d45-42b5-b3d0-c4ff053f4288');
      // this.$store.commit('setProcessId', '43980459-8496-46ce-8d1c-be53bbc152df');
      this.defaultParam = {'processId': this.processId};
      this.url = activeLicense.selAuthorizeList;
    }
    this.$refs.tableObj.setTableData(this.tableData.slice())
    this.checkTableRow(this.checkTableData);
    // this.$forceUpdate();
  },
  deactivated(){
    this.$store.commit('setCheckTableData', this.currentCheck);
    this.$store.commit('setBindTableData', this.currentCheck);
  },
  methods:{
    licenseKeyValidate(rule, value, callback){
      let param ={
        'processId': this.processId,
        'licenseKeyList': [value],
        'cacheKey': this.cacheKey,
        'step': '1'
      }
      this.loading = true;
      requestActiveLicense.saveAuthorizeInfo(param).then(res => {
        this.loading = false;
        if (res.code == '0') {
          this.form.code = '';
          let resTable = res.res.concat(this.tableData);
          let checkResTable = res.res.concat(this.checkTableData);
          this.$store.commit('setTableData', resTable);
          this.$store.commit('setCheckTableData', checkResTable);
          this.$refs.tableObj.setTableData(resTable); //刷新表格
          this.checkTableRow(checkResTable)
        } else {
          callback(res.msg || '操作失败')
        }
      })
      .catch(error => {
        this.loading = false;
        callback('操作失败')
      });
    },
    productCodeClick(list){
      if(Array.isArray(list) && list.length){
        const url = (list[0] || {}).url;
        if(!url){
          this.$notify({
            title: '提示',
            message: '无匹配的License使用指南',
            type: 'warning',
          });
          return;
        }
        window.open(url);
      }
    },
    getVail(){
      return new Promise((resovle, reject) => {
        if(!this.currentCheck.length){
          this.$notify({
            title: '提示',
            message: '请至少选择一个有效的授权码！',
            type: 'warning',
          });
          return reject();
        }
        resovle();
      })
    },
    dataLoadSuccess(res){
      this.$store.commit('setTableData', res.res);
      this.$store.commit('setCheckTableData', res.res);
      this.checkTableRow(res.res);
    },
    // 选中行
    checkTableRow(rows){
      Promise.resolve().then(()=>{
        this.$refs.tableObj.clearSelection();
        rows.forEach(row => {
          this.$refs.tableObj.toggleRowSelection(row, true);
        })
      })
    },
    dataLoadFail(){
      this.$store.commit('setTableData', []);
    },
    deleteCodeValue(){
      this.form.code = '';
    },
    refeshData(){
      this.$refs.tableObj.refreshData(); //刷新表格
    },
    handleSelectionChange(selection){
      this.currentCheck = selection;
      this.$store.commit('setCheckTableData', this.currentCheck);
    },
    seeHelp(){
      window.open(`${location.origin}/document/license_activation_step1.html`);
    },
    clickCode(){
      this.dialogCodeFlag = true;
    },
    cancelCodeDialog(codeValue){
      if(codeValue){
        this.form.code = codeValue;
      }
      this.dialogCodeFlag = false;
    },
    batchAdd(){
      this.dialogCodeImportFlag = true;
    },
    cancelCodeImportDialog(list){
      // 待修改
      this.dialogCodeImportFlag = false;
      if(list){
        let resTable = list.concat(this.tableData);
        let checkResTable = list.concat(this.checkTableData);
        this.$store.commit('setTableData', resTable);
        this.$store.commit('setCheckTableData', checkResTable);
        this.$refs.tableObj.setTableData(resTable); //刷新表格
        this.checkTableRow(checkResTable)
      }
    },
    closeTip(){
      this.tipShow = false;
    },
    add(){
      this.$refs.formRef.validateField(`code`,  (err) => {})
    },
    handleConfirm(){
      // const currentCheck = this.currentCheck.slice();
      const currentCheck = this.getCurrentPageCheck();
      const ids = currentCheck.map(item => item.id);
      const param = {
        ids,
        'processId': this.processId,
        'licenseKeyList': currentCheck.map(item => item.licenseKey),
        'cacheKey': this.cacheKey,
        'step': '1'
      }
      requestActiveLicense.removeAuthorizeInfos(param).then(res => {
        this.loading = false;
        if (res.code == '0') {
          this.$notify({
            title: '成功',
            message: res.msg || '操作成功',
            type: 'success',
          });
          currentCheck.forEach(item => {
            this.$store.commit('spliceTableData', item);
            this.$store.commit('spliceCheckTableData', item);
          })
          this.$refs.tableObj.setTableData(this.tableData); //刷新表格
          this.checkTableRow(this.checkTableData)
          // this.$refs.tableObj.refreshData(); //刷新表格
        }
      })
      .catch(error => {
        this.loading = false;
        this.$notify({
          title: '失败',
          message: '操作失败',
          type: 'error',
        });
      });
    },
    handleClose(){
      this.dialogCommon = false;
    },
    // 获取当前页选中数据
    getCurrentPageCheck(){
      // 当前页数据
      const formTableCurrent = this.$refs.tableObj.getFormTableCurrent();
      // 所有选中数据
      const currentCheck = this.currentCheck.slice();
      let result = [];
      formTableCurrent.forEach(item => {
        let flag = currentCheck.some(check =>{
          return check === item
        })
        flag && result.push(item);
      })
      return result;
    },
    remove(){
      // const currentCheck = this.currentCheck.slice();
      const currentCheck = this.getCurrentPageCheck();
      if(!currentCheck.length){
        this.$notify({
          title: '提示',
          message: '请至少选择一个有效的授权码！',
          type: 'warning',
        });
        return;
      }
      this.dialogCommon = true;
    }
  }
}
</script>
<style lang="less" scoped>
.addInfoWrap{
  width: 100%;
  height: 100%;
  display: flex;
  flex-direction: column;
  .textTip{
    margin-bottom: 15px;;
  }
  .addFrom{
    display: flex;
    z-index: 9;
    .el-form-item{
      // margin-bottom: 12px;
      /deep/ .el-form-item__label{
        color: #333333;
      }
      /deep/ .el-input__inner{
        color: #333333;
      }
    }
    .rightFlexItem{
      flex: 1;
      text-align: right;
    }
    .inputImgWrap{
      height: 100%;
      display: flex;
      align-items: center;
      .inputImgClass{
        width: 14px;
        height: 14px;
        cursor: pointer;
      }
      .rightClass{
        margin-right: 10px;
      }
    }
  }
  .serverTable{
    flex: 1;
    .productCode{
      cursor: pointer;
      color: @currentColor;
      overflow: hidden;
      text-overflow: ellipsis;
    }
  }
}
</style>